var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-2", class: ["col-" + _vm.colSize] }, [
    _c("div", { staticClass: "form-page" }, [
      _c("p", { staticClass: "text-justify" }, [
        _vm._v("\n      " + _vm._s(_vm.prompt) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "mb-0", class: _vm.articleClass },
        _vm._l(_vm.options, function (option) {
          return _c(
            "div",
            {
              key: option.id,
              staticClass: "form-container fe-radio-form large-radio px-0",
              class: "ml-" + _vm.margin,
              staticStyle: { width: "initial" },
            },
            [
              option.multi
                ? _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-jelly p-smooth p-curve my-3 multi-line",
                    },
                    [
                      _c("input", {
                        staticClass: "checkbox",
                        attrs: {
                          id: option.id,
                          name: option.id,
                          type: "checkbox",
                          disabled: _vm.disabled,
                        },
                        domProps: {
                          value: option.value,
                          checked: _vm.checkedMap[option.value],
                        },
                        on: { change: _vm.handleMultiChange },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-success" }, [
                        _c("i", { staticClass: "icon fa fa-check" }),
                        _vm._v(" "),
                        option.text
                          ? _c("label", { attrs: { for: option.id } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(option.text) +
                                  "\n            "
                              ),
                            ])
                          : option.html
                          ? _c("label", {
                              attrs: { for: option.id },
                              domProps: { innerHTML: _vm._s(option.html) },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "fe-option col-xs-12 multi-line my-3 h-auto",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.answer.option,
                            expression: "answer.option",
                          },
                        ],
                        attrs: {
                          id: "" + option.id,
                          type: "radio",
                          disabled: _vm.disabled,
                        },
                        domProps: {
                          value: option.value,
                          checked: _vm._q(_vm.answer.option, option.value),
                        },
                        on: {
                          change: [
                            function ($event) {
                              return _vm.$set(
                                _vm.answer,
                                "option",
                                option.value
                              )
                            },
                            _vm.handleChange,
                          ],
                          click: function ($event) {
                            return _vm.changes(option)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkmark" }),
                      _vm._v(" "),
                      option.text
                        ? _c("label", { attrs: { for: "" + option.id } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.text) +
                                "\n          "
                            ),
                          ])
                        : option.html
                        ? _c("label", {
                            attrs: { for: "" + option.id },
                            domProps: { innerHTML: _vm._s(option.html) },
                          })
                        : _vm._e(),
                    ]
                  ),
              _vm._v(" "),
              option.comparison
                ? _c("p", { staticClass: "mt-3 text-uppercase" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.or")) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              option.textExplain
                ? _c(
                    "div",
                    {
                      staticClass:
                        "form-group-material form-group-material-no-label",
                    },
                    [
                      _c(_vm.inputComponent(option.textExplainType), {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.answer.option == option.value,
                            expression: "answer.option == option.value",
                          },
                        ],
                        tag: "component",
                        style: { resize: option.resize },
                        attrs: {
                          title: option.textExplainLabel || "",
                          prompt: option.textExplainLabel || "",
                          value: _vm.answer.text,
                          cols: option.cols || "4",
                          maxrows: option.maxrows || "",
                          maxlength: option.maxlength || "",
                        },
                        on: { input: _vm.handleExplainChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }